import axios from "services/api";
import { ELVIS_URL } from "helpers/urlHelper";
export const uploadFile = async formData => {
  const res = await axios({
    url: `${ELVIS_URL}/api/files/upload`,
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return res.data;
};

export const getPresignedFile = async id => {
  const res = await axios({
    url: `${ELVIS_URL}/api/files/s3-presign`,
    method: 'GET',
    params: { id }
  });
  return res.data;
};
